// Internal team auto emails go out as ONE email: one primary recipient (the listing agent when they're on it),
// everyone else on the team CC'd. Client / outside recipients are left alone (still one each, still approval-gated).
// Kelly, Oct 30: "one email with everyone copied on it."
const INTERNAL = ['agent', 'co-agent', 'tc', 'transaction coordinator', 'marketing manager', 'local assistant', 'admin'];
const isInternalRole = (role) => INTERNAL.includes(String(role || '').trim().toLowerCase());
const lc = (e) => String(e || '').trim().toLowerCase();

// recipients: [{ role, name, email }]. extraCc: addresses that would have been CC'd anyway (agents).
// Returns { group: { primary, cc, members } | null, others: [...] }.
function groupInternal(recipients, { primaryEmail = '', extraCc = [] } = {}) {
  const seen = new Set(); const internal = []; const others = [];
  for (const r of recipients || []) {
    if (!r || !r.email) continue;
    const k = lc(r.email); if (seen.has(k)) continue; seen.add(k);
    (isInternalRole(r.role) ? internal : others).push(r);
  }
  if (!internal.length) return { group: null, others };
  const primary = internal.find((r) => primaryEmail && lc(r.email) === lc(primaryEmail)) || internal[0];
  const ccSet = new Set(); const cc = [];
  for (const e of [...internal.map((r) => r.email), ...(extraCc || [])]) {
    const k = lc(e); if (!k || k === lc(primary.email) || ccSet.has(k)) continue; ccSet.add(k); cc.push(String(e).trim());
  }
  return { group: { primary, cc, members: internal }, others };
}

export { groupInternal, isInternalRole };
